export const initTopMenuDropdown = () => {
	const parents = document.querySelectorAll(".top-menu__item--parent");

	if (!parents.length) {
		return;
	}

	const closeItem = (item) => {
		item.classList.remove("is-open");
		const toggle = item.querySelector(".top-menu__toggle");
		if (toggle) {
			toggle.setAttribute("aria-expanded", "false");
		}
	};

	const openItem = (item) => {
		item.classList.add("is-open");
		const toggle = item.querySelector(".top-menu__toggle");
		if (toggle) {
			toggle.setAttribute("aria-expanded", "true");
		}
	};

	parents.forEach((item) => {
		const toggle = item.querySelector(".top-menu__toggle");
		if (!toggle) {
			return;
		}

		if (
			item.classList.contains("is-selected") &&
			window.matchMedia("(max-width: 1239px)").matches
		) {
			openItem(item);
		}

		toggle.addEventListener("click", (evt) => {
			if (window.matchMedia("(min-width: 1240px)").matches) {
				return;
			}

			evt.preventDefault();
			evt.stopPropagation();

			const isOpen = item.classList.contains("is-open");

			parents.forEach((other) => {
				if (other !== item) {
					closeItem(other);
				}
			});

			if (isOpen) {
				closeItem(item);
			} else {
				openItem(item);
			}
		});
	});
};
